import { useSafeAreaFrame } from "react-native-safe-area-context";
import { Platform, ScrollView } from "react-native";
import LBox from "@components/LBox";
import Background from "../components/common/Background";
import AndroidDismissButton from "../components/common/AndroidDismissButton";
import Handle from "../components/common/Handle";
import { theme } from "@theme";
import { useAccessViewport } from "../config";
import { AccessDetailsDismiss } from "../types";

type DetailsLayoutProps = {
  children:
    | React.ReactNode
    | ((props: { dismiss: AccessDetailsDismiss }) => React.ReactNode);
  dismiss: AccessDetailsDismiss;
  imageUrl: string | null;
};

const DetailsLayout = ({ children, dismiss, imageUrl }: DetailsLayoutProps) => {
  const { width: screenWidth, height: screenHeight } = useAccessViewport();
  const frame = useSafeAreaFrame();

  // useSafeAreaFrame provides consistent dimensions across Android versions,
  // representing the full frame of the SafeAreaProvider (includes system bar areas).
  const dynamicMinHeight =
    Platform.OS === "android" ? frame.height : screenHeight;

  return (
    <>
      <Background imageUrl={imageUrl} />
      <AndroidDismissButton onPress={() => dismiss()} />
      {Platform.OS === "web" && <Handle onDismiss={dismiss} />}
      <LBox minHeight={dynamicMinHeight}>
        <ScrollView
          style={{
            flexGrow: 1,
            ...(Platform.OS === "web" && { height: screenHeight }),
          }}
          contentContainerStyle={{
            backgroundColor: "transparent",
            padding: theme.spacing.s4,
            paddingTop: Platform.OS === "web" ? 0 : theme.spacing.s4,
            paddingBottom: theme.spacing.xl1,
            gap: theme.spacing.s3,
            flexGrow: 1,
            width: screenWidth,
          }}
        >
          {typeof children === "function" ? children({ dismiss }) : children}
        </ScrollView>
      </LBox>
    </>
  );
};

export default DetailsLayout;
